export const SET_PLAY_SETTINGS = "SET_PLAY_SETTINGS";
export const SET_PLAY_FLAGS = "SET_PLAY_FLAGS";
export const RESET_PLAY_SETTINGS = "RESET_PLAY_SETTINGS";
